<template>
  <div class="fou--bannerDiv">
    <span class="fou--banner-icon" data-qa-id="email-verify-banner-warning-icon">
      <WarningIconTriangle
        :width="24"
        fill-background-color="#F2B500"
        remove-vertical-offset
      />
    </span>
    <div class="fou--banner-body">
      <p v-if="labelKey" class="fou--banner-label" data-qa-id="email-verify-banner-label">
        {{ $t(labelKey) }}
      </p>
      <MdButton
        v-if="showVerifyButton"
        data-qa-id="email-verify-banner-button"
        variant="ghost"
        class="fou--banner-button"
        @click="openEmailVerificationModal"
      >
        {{ $t('components.general.verify_email.banner.button_label') }}
      </MdButton>
    </div>
    <span
      v-if="showCloseIcon"
      class="fou--banner-icon fou--banner-cell--close"
      role="button"
      tabindex="0"
      aria-label="Close"
      data-qa-id="email-verify-banner-close"
      @click="dismissBanner"
    >
      <CloseIcon />
    </span>
  </div>
</template>
<script src="./script.js"></script>
<style lang="scss" src="./stylesheet/index.scss" />
